"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var filterable_select_menu_html_1 = __importDefault(require("./filterable-select-menu.html"));
require("./filterable-select-menu.less");
(function (module) {
    'use strict';
    function FilterableSelectMenuController($scope, $filter) {
        var $ctrl = this;
        $scope.$ctrl = $ctrl;
        angular.extend($ctrl, {
            $onInit: function () {
                $ctrl.search = '';
                $ctrl.updateFilteredItems();
            },
            updateFilteredItems: function () {
                $ctrl.filteredItems = $filter('filter')($ctrl.items, $ctrl.search);
                updateCounts();
            },
            selectAll: function () {
                _.forEach($ctrl.filteredItems, function (item) {
                    item.selected = $ctrl.allSelected;
                });
                updateCounts();
            },
            toggleItem: function () {
                updateCounts();
            }
        });
        function updateCounts() {
            $ctrl.selectedItems = _.filter($ctrl.items, { selected: true });
            updateWidgetCount();
            // if no items is found, ignore allSelected
            if (!$ctrl.filteredItems.length) {
                return;
            }
            var selectedFilteredItems = _.filter($ctrl.filteredItems, { selected: true });
            if (selectedFilteredItems.length === $ctrl.filteredItems.length) {
                $ctrl.allSelected = true;
            }
            else {
                $ctrl.allSelected = false;
            }
        }
        function updateWidgetCount() {
            $ctrl.widgetCount = 0;
            _.forEach($ctrl.selectedItems, function (page) {
                if (page.widgets && page.widgets.length) {
                    $ctrl.widgetCount += page.widgets.length;
                }
            });
        }
    }
    FilterableSelectMenuController.$inject = [
        '$scope',
        '$filter',
    ];
    module.component('prFilterableSelectMenu', {
        templateUrl: filterable_select_menu_html_1.default,
        controller: FilterableSelectMenuController,
        bindings: {
            items: '=',
            widgetCount: '='
        }
    });
})(angular.module('qualtrics.pr'));
